import { DashboardOutlined, UserSwitchOutlined, BankOutlined, UsergroupAddOutlined, DollarCircleOutlined, CreditCardOutlined, HeartOutlined, SolutionOutlined, TransactionOutlined, FileSearchOutlined } from '@ant-design/icons';
const icons = {
  DashboardOutlined,
  UserSwitchOutlined,
  BankOutlined,
  UsergroupAddOutlined,
  DollarCircleOutlined,
  CreditCardOutlined,
  HeartOutlined,
  SolutionOutlined,
  TransactionOutlined,
  FileSearchOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const ngoMenu = {
  items: [
    {
      id: 'group-dashboard',
      title: 'Dashboard',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/ngo/dashboard',
          icon: icons.DashboardOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'users',
      title: 'User Management',
      type: 'group',
      children: [
        {
          id: 'Institution',
          title: 'Institutions',
          type: 'item',
          url: '/ngo/institution',
          icon: icons.BankOutlined,
          target: false
        },
        {
          id: 'institutionRequests',
          title: 'Institution Requests',
          type: 'item',
          url: '/ngo/institution-requests',
          icon: icons.FileSearchOutlined,
          target: false
        },
        {
          id: 'beneficiary',
          title: 'Beneficiaries',
          type: 'item',
          url: '/ngo/beneficiary',
          icon: icons.UsergroupAddOutlined
        },
        {
          id: 'Donors',
          title: 'Donors',
          type: 'item',
          url: '/ngo/donor',
          icon: icons.DollarCircleOutlined
        },
      ]
    },
    {
      id: 'transactions',
      title: 'Transactions',
      type: 'group',
      children: [
        {
          id: 'requests',
          title: 'Requests',
          type: 'item',
          url: '/ngo/requests',
          icon: icons.SolutionOutlined
        },
        {
          id: 'donations',
          title: 'Donations',
          type: 'item',
          url: '/ngo/donations',
          icon: icons.HeartOutlined
        },
      ]
    }
  ]
};

export default ngoMenu;
